// This is used to get the route hash
export function getRouteLink(route) {
	return `${route.verbs[0]}${route.path[0]
		.replace(/{|}|[/]v1/g, '')
		.replace(/[/]/g, '-')}`.toLowerCase()
}

// Sort the API routes in a fancy way
export function sortApiRoutes(routes) {
	const orderedVerbs = ['GET', 'POST', 'PUT', 'DELETE', 'OPTIONS']
	let mapped = routes.map((el, i) => ({ index: i, verb: el.verbs[0], path: el.name[0] }))

	mapped.sort(function(a, b) {
		var c = orderedVerbs.indexOf(a.verb) - orderedVerbs.indexOf(b.verb)
		if (c !== 0) return c
		if (a.path < b.path) return -1
		if (a.path > b.path) return 1
		return 0
	})

	return mapped.map(el => routes[el.index])
}

export function cleanRequestName(apiRequest) {
	var simple = apiRequest.replace('Request', '')
	simple = simple.replace('Response', '')
	simple = simple.replace('Put', '')
	simple = simple.replace('Upload', '')
	var bits = simple.split(/(?=[A-Z])/)

	return bits.join('')
}

export const primitives = ['string', 'dateTime', 'bool', 'int', 'long', 'guid', 'Stream']



// WEBPACK FOOTER //
// ./src/helpers/helpers.js